import { useState, useEffect } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../../shared/constants'

const QuizReport = () => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })

  const filterData = state.data
  const [page, setPage] = useState(1)

  //? useEffect
  useEffect(() => {
    getAllData('GET_QUIZ_REPORT', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  console.log({ filterData })
  console.log({ state })

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item, index) => {
      return [
        { value: item.contentName },
        { value: item.category },
        { value: item.contentType },
        { value: item.attempted },
        { value: item.maxScore },
        { value: item.minScore },
        { value: item.meanScore },
      ]
    })
  }

  const layoutProps = {
    heading: 'Quiz Report',
    filename: 'quizReport',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Content Name', 'Category', 'Content Type', 'attempted', 'maxScore', 'minScore', 'meanScore']}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}

export default QuizReport
